<template>
  <!-- 订单表示例 -->
  <!-- :row-class-name="rowClass" 用于添加表格选中底色，rowClass回调 定义在crudmixins混入文件里 -->
  <div>
    <avue-crud
      :option="option"
      :table-loading="loading"
      :data="data"
      :page.sync="page"
      :search.sync="defaults"
      :permission="permissionList"
      :before-open="beforeOpen"
      v-model="form"
      ref="crud"
      @row-update="rowUpdate"
      @row-save="rowSave"
      @row-del="rowDel"
      @search-change="searchChange"
      @search-reset="searchReset"
      @selection-change="selectionChange"
      @current-change="currentChange"
      @size-change="sizeChange"
      @refresh-change="refreshChange"
      @on-load="onLoad"
      :row-class-name="rowClass"
    >
      <!-- 自定义列表多功能栏 -->
      <table-column-set :THIS_TO_PARENT="this" slot="menuRight" />
      <!-- 自定义列表左上插槽 -->
      <template slot="menuLeft">
        <el-button
          size="small"
          type="danger"
          icon="el-icon-delete"
          @click="handleDelete"
          v-if="permission.order_del"
          >删除
        </el-button>
        <el-button
          size="small"
          plain
          icon="el-icon-circle-check"
          @click="handleAudit"
          v-if="permission.order_audit"
          >审核
        </el-button>
        <el-button
          size="small"
          icon="el-icon-close"
          type="danger"
          @click="handleToVoid"
          v-if="permission.order_void"
          >作废
        </el-button>
        <!-- 前端导出示例（支持列显隐及查询）-->
        <!-- 1. 提供给导出使用的接口需要后端同名转义， 导出默认不传分页参数返回全部数据即可 -->
        <!-- 2. 不考虑后台返回数据速度 组件可导出十万级数据量数据。 因数据返回慢建议控制在一万条内-->
        <!-- 3. 为控制数据量组件内已把searchDate查询字段 处理为空时默认一个月 超过一个月不导出， 数据返回快可直接删除判断-->
        <!-- 4. 不同同名转义的字段 可使用 exportProp 属性填写上实际的转义字段-->
        <export-by-page-json
          FileName="示例导出"
          :downloadQuery="query"
          :config="{
            url: '/api/blade-demo/demoOrder/exportSync',
            ColumnData: option.column,
            buttonName: '前端导出Excel示例',
          }"
          :key="downloadkey"
          @reset="() => (downloadkey = !downloadkey)"
          v-if="permission.order_import"
        >
        </export-by-page-json>
        <!-- 后端异步导出 -->
        <export-by-request
          :downloadQuery="query"
          :config="{
            url: '/api/blade-demo/demoOrder/exportAsync',
            ColumnData: option.column,
            buttonName: '后端导出Excel示例',
          }"
          v-if="permission.order_import"
        >
        </export-by-request>
        <!-- 导入订单 -->
        <el-button
          size="small"
          plain
          @click="onImport()"
          icon="el-icon-upload2"
          v-if="permission.order_export"
          >导入</el-button
        >
      </template>

      <!-- 保留小数位类字段 可采用组件或验证方式二选一    -->
      <template slot="countAmountForm">
        <custom-input v-model="form.countAmount" precision="2"></custom-input>
      </template>
      <!-- 物资客户等拼音码相关字段，使用组件解决：
             1.修改时默认三十条无法转义问题
             2.默认组件不符合业务要求 如辅助录入 粘贴处理等。
      -->
      <template slot="varNoNameForm">
        <autocomplete-reset
          v-model="form.varNoName"
          typeUse="varNo"
          :formData="form"
        />
      </template>
      <template slot="custNoNameForm">
        <autocomplete-reset
          v-model="form.custNoName"
          typeUse="custNo"
          :formData="form"
        />
      </template>
    </avue-crud>

    <dialog-reset
      title="订单数据导入"
      :visible.sync="excelBox"
      height="auto"
      width="650px"
    >
      <avue-form
        :option="excelOption"
        v-model="excelForm"
        :upload-after="uploadAfter"
      >
        <template slot="excelTemplate">
          <el-button type="primary" @click="handleTemplate">
            点击下载<i class="el-icon-download el-icon--right"></i>
          </el-button>
        </template>
      </avue-form>
    </dialog-reset>
  </div>
</template>
<script>
import {
  getList,
  getDetail,
  add,
  update,
  remove,
  audit,
  toVoid,
} from "@/api/demo/order";
import crudmixins from "@/basic-common/mixins/crudmixins.js";
import { mapGetters } from "vuex";
import validator from "@/util/validate.js";
import { desensitizationDispose } from "@/basic-common/util/desensitization.js";
import { numSeparator } from "@/basic-common/util/common.js";
import ExportByRequest from "@/basic-common/components/ExportByRequest";
import ExportByPageJson from "@/basic-common/components/ExportByPageJson.vue";
import { getToken } from "@/util/auth";
const mixin = new crudmixins({ add, getDetail, getList, remove, update });

export default {
  mixins: [mixin],
  data() {
    return {
      downloadkey: true,
      excelBox: false,
      // 具体option配置参考avue官网配置
      option: {
        ...this.$store.state.publicOption, //需要写到option首位否则在当前option覆盖不掉 publicOption具体参数见：src\store\index.js
        dialogWidth: "60%", //avue操作集成对话框宽度
        labelWidth: 100,
        menuWidth: 120,
        column: [
          {
            label: "单位",
            prop: "deptId",
            exportProp: "deptIdName",
            type: "tree",
            dataType: "string",
            search: true,
            forbiddenQuery: true,
            overHidden: true,
            searchMultiple: true,
            defaultExpandAll: true,
            checkStrictly: true,
            dicUrl: "/api/blade-system/dept/treeByUser",
            props: {
              label: "deptName",
              value: "id",
            },
            rules: [
              {
                required: true,
                message: "请选择单位",
                trigger: "blur",
              },
            ],
          },
          {
            label: "订单编码",
            prop: "orderNo",
            overHidden: true,
            search: true,
            maxlength: 32,
            editDisabled: true,
            rules: [
              {
                required: true,
                message: "请输入订单编码",
                trigger: "blur",
              },
            ],
          },
          {
            label: "物资名称",
            prop: "varNo",
            type: "select",
            hide: true,
            search: true,
            addDisplay: false,
            editDisplay: false,
            viewDisplay: false,
            overHidden: true,
            showColumn: false,
            remote: true,
            dicUrl: "/api/blade-vardict/vardict/searchCode?searchCode={{key}}",
            props: {
              label: "varName",
              value: "varNo",
            },
          },
          {
            label: "物资名称",
            prop: "varNoName",
            overHidden: true,
            rules: [
              {
                required: true,
                message: "请输入物资名称",
                trigger: "change",
              },
            ],
          },
          {
            label: "货主",
            prop: "custNo",
            type: "select",
            hide: true,
            showColumn: false,
            addDisplay: false,
            editDisplay: false,
            viewDisplay: false,
            overHidden: true,
            remote: true,
            dicUrl: '/api/produce/blade-dept/select/distinct/select',
            props: {
              label: 'deptName',
              value: 'id'
            },
          },
          {
            label: "货主",
            prop: "custNoName",
            overHidden: true,
            rules: [
              {
                required: true,
                message: "请输入货主",
                trigger: "change",
              },
            ],
          },
          {
            label: "订单量(吨)",
            prop: "countAmount",
            align: "right",
            maxlength: 9,
            numFormat: true,
            formslot: true,
            overHidden: true,
            rules: [
              {
                required: true,
                validator: validator.positiveNum2,
                trigger: "blur",
              },
            ],
          },
          {
            label: "发运量(吨)",
            prop: "shipAmount",
            numFormat: true,
            align: "right",
            addDisplay: false,
            editDisplay: false,
            viewDisplay: true,
            overHidden: true,
          },
          {
            label: "剩余量(吨)",
            prop: "remainAmount",
            numFormat: true,
            align: "right",
            overHidden: true,
            addDisplay: false,
            editDisplay: false,
            viewDisplay: true,
          },
          {
            label: "状态",
            prop: "status",
            type: "select",
            dataType: "string",
            exportProp: "statusName",
            addDisplay: false,
            editDisplay: false,
            viewDisplay: true,
            showColumn: false,
            overHidden: true,
            dicUrl: "/api/blade-system/dict-biz/dictionary?code=status_flag",
            props: {
              label: "dictValue",
              value: "dictKey",
            },
          },
          {
            label: "审核状态",
            prop: "auditFlag",
            type: "select",
            dataType: "string",
            exportProp: "auditFlagName",
            search: true,
            addDisplay: false,
            editDisplay: false,
            viewDisplay: true,
            showColumn: false,
            overHidden: true,
            dicUrl: "/api/blade-system/dict-biz/dictionary?code=audit_flag",
            props: {
              label: "dictValue",
              value: "dictKey",
            },
          },
          {
            label: "审核人",
            prop: "auditUserName",
            showColumn: false,
            addDisplay: false,
            editDisplay: false,
            viewDisplay: true,
            overHidden: true,
          },
          {
            label: "审核时间",
            prop: "auditTime",
            hide: true,
            showColumn: false,
            addDisplay: false,
            editDisplay: false,
            viewDisplay: true,
            overHidden: true,
          },
          {
            label: "录入人",
            prop: "createUserName",
            showColumn: false,
            addDisplay: false,
            editDisplay: false,
            viewDisplay: true,
            overHidden: true,
          },
          {
            label: "录入时间",
            prop: "createTime",
            showColumn: false,
            addDisplay: false,
            editDisplay: false,
            viewDisplay: true,
            overHidden: true,
          },
          {
            label: "更新人",
            prop: "updateUserName",
            hide: true,
            showColumn: false,
            addDisplay: false,
            editDisplay: false,
            viewDisplay: true,
            overHidden: true,
          },
          {
            label: "更新时间",
            prop: "updateTime",
            hide: true,
            showColumn: false,
            addDisplay: false,
            editDisplay: false,
            viewDisplay: true,
            overHidden: true,
          },
          {
            label: "备注",
            prop: "remark",
            type: "textarea",
            hide: true,
            maxlength: 200,
            showWordLimit: true,
            span: 24,
            minRows: 6,
            overHidden: true,
          },
          {
            label: "查询时间",
            prop: "searchDate",
            type: "datetime",
            dataType: "string",
            hide: true,
            showColumn: false,
            search: true,
            addDisplay: false,
            editDisplay: false,
            viewDisplay: false,
            dateDefault: true,
            overHidden: true,
            searchRange: true,
            format: "yyyy-MM-dd HH:mm:ss",
            valueFormat: "yyyy-MM-dd HH:mm:ss",
          },
        ],
      },
      excelForm: {},
      excelOption: {
        submitBtn: false,
        emptyBtn: false,
        column: [
          {
            label: "文件上传",
            prop: "excelFile",
            type: "upload",
            drag: true,
            loadText: "文件上传中，请稍等",
            showFileList: false,
            propsHttp: {
              res: "data",
            },
            tip: "请上传 .xls,.xlsx 标准格式文件",
            action: "/api/blade-demo/demoOrder/importSync",
          },
          {
            label: "数据覆盖",
            prop: "isCovered",
            type: "switch",
            value: 0,
            span: 24,
            slot: true,
            dicData: [
              {
                label: "否",
                value: 0,
              },
              {
                label: "是",
                value: 1,
              },
            ],
            rules: [
              {
                required: true,
                message: "请选择是否覆盖",
                trigger: "blur",
              },
            ],
          },
          {
            label: "模板下载",
            prop: "excelTemplate",
            formslot: true,
          },
        ],
      },
    };
  },
  watch: {
    "excelForm.isCovered"() {
      if (this.excelForm.isCovered !== "") {
        const column = this.findObject(this.excelOption.column, "excelFile");
        column.action = `/api/blade-demo/demoOrder/importSync?isCovered=${this.excelForm.isCovered}`;
      }
    },
  },
  computed: {
    ...mapGetters(["permission"]),
    permissionList() {
      return {
        addBtn: this.vaildData(this.permission.order_add, false),
        viewBtn: this.vaildData(this.permission.order_view, false),
        editBtn: this.vaildData(this.permission.order_edit, false),
        delBtn: false,
      };
    },
    ids() {
      let ids = [];
      this.selectionList.forEach((ele) => {
        ids.push(ele.id);
      });
      return ids.join(",");
    },
  },
  components: {
    ExportByRequest,
    ExportByPageJson,
  },
  methods: {
    // 自定义审核
    handleAudit() {
      if (this.selectionList.length === 0) {
        this.$message.warning("请选择至少一条数据");
        return;
      }
      this.$confirm_primary("审核")
        .then(() => {
          return audit(this.ids);
        })
        .then((res) => {
          this.onLoad(this.page);
          this.$message({
            type: "success",
            message: res.data.msg,
          });
        });
    },
    // 自定义作废
    handleToVoid() {
      if (this.selectionList.length === 0) {
        this.$message.warning("请选择至少一条数据");
        return;
      }
      this.$confirm_danger("作废")
        .then(() => {
          return toVoid(this.ids);
        })
        .then((res) => {
          this.onLoad(this.page);
          this.$message({
            type: "success",
            message: res.data.msg,
          });
        });
    },
    // 编辑时前台限制不可操作数据类型 此功能包含已审核已作废
    beforeOpen(done, type) {
      if (["edit", "view"].includes(type)) {
        if (type == "edit") {
          if (this.form.auditFlag === "1")
            return this.$message.warning("请操作未审核的数据");
          if (this.form.status === "0")
            return this.$message.warning("请操作未作废的数据");
        }
        getDetail(this.form.id).then((res) => {
          /* numSeparator 千位符处理 numFormat开启传入option*/
          res.data.data = numSeparator(res.data.data, this.option, type);
          /* desensitizationDispose 脱敏处理 */
          this.form = desensitizationDispose(res.data.data, type);
        });
      } else if (type == "add") {
        this.form = {};
      }
      done();
    },
    onImport() {
      this.excelForm.isCovered = 0;
      this.excelBox = true;
    },
    uploadAfter(res, done) {
      if (!(res instanceof Error)) {
        this.$message.success("上传成功");
      }
      this.excelBox = false;
      this.onLoad(this.page, this.query);
      done();
    },
    handleTemplate() {
      window.open(
        `/api/blade-demo/demoOrder/exportTemplate?${
          this.website.tokenHeader
        }=${getToken()}`
      );
    },
  },
};
</script>
